import { ContactGroupReference } from './../contacts/ContactGroupStore';
import {
  getRoot,
  IAnyModelType,
  Instance,
  SnapshotIn,
  SnapshotOut,
  types,
} from 'mobx-state-tree';
import { RootModelType } from '../Root';
import { modelWithCRUD } from '../utils/modelWithCRUD';

export const ProductGroup = types.model('ProductGroup', {
  id: types.union(types.identifier, types.identifierNumber),
  name: types.string,
  description: types.maybeNull(types.string),
  default_cmr: types.number,

  pricing: types.array(
    types.model({
      cmr: types.number,
      contact_group: types.late(() => ContactGroupReference),
    })
  ),

  products__count: types.optional(types.number, 0),
});

export const ProductGroupStore = modelWithCRUD(
  'product-groups',
  ProductGroup
).named('ProductGroupStore');

export const ProductGroupReference = types.reference(
  types.late((): IAnyModelType => ProductGroup),
  {
    get(identifier, parent): any {
      return (getRoot(parent!) as RootModelType).productGroupStore.getItemNaive(
        identifier
      );
    },
    set(value) {
      return value.id;
    },
  }
);

export interface IProductGroup extends Instance<typeof ProductGroup> {}
export interface IProductGroupSnapshotIn
  extends SnapshotIn<typeof ProductGroup> {}
export interface IProductGroupSnapshotOut
  extends SnapshotOut<typeof ProductGroup> {}
